import { apiActions, commonActions } from '../app/actions';
import { makeRequest } from '../lib/fetch';
import { fireMessageEvent } from '../messenger/utils';

export const playersPicked = () => (dispatch) => {
  const { setValue } = commonActions('player_picks_submitted');
  dispatch(setValue());
};

export const noContestToday = () => (dispatch) => {
  const { setValue } = commonActions('no_contest_today');
  dispatch(setValue());
};

export const playerPicksSubmitted = (picks) => (dispatch) => {
  const { setValue } = commonActions('player_picks_submitted');
  dispatch(setValue(picks));
};

export const fetchPlayerData = () => (dispatch, getState) => {
  const { config } = getState();
  const { apiUrl, graphqlUrl, language, env, userId, currentSession, platform } = config;

  const { fetchStart, fetchSuccess, fetchFailure } = apiActions('player_data');

  dispatch(fetchStart());

  return makeRequest({
    method: 'GET',
    route: 'players',
    apiUrl,
    graphqlUrl,
    language,
    platform,
    env,
    userId,
    currentSession,
  }).then(
    (resp) => {
      if (resp.code === 'serverError') {
        return dispatch(fetchFailure(resp));
      }

      if (resp.code === 'noContest') {
        return dispatch(noContestToday());
      }

      if (resp.picks) {
        return dispatch(playerPicksSubmitted(resp));
      }

      return dispatch(fetchSuccess(resp));
    },
    (err) => {
      if (err?.status === 401) {
        return dispatch(apiActions('auth').fetchFailure());
      }
      const messageData = {
        err,
        route: 'players',
        apiUrl,
        userId,
        currentSession,
      };
      fireMessageEvent({
        type: 'ERROR',
        platform,
        title: 'hockey-challenge-error',
        data: messageData,
      });
      if (err?.code === 500) {
        return dispatch(apiActions('data_500').fetchFailure(err));
      }
      return dispatch(fetchFailure(err));
    },
  );
};
